import {
  Card, HStack, Skeleton, Spacing, Stack,
} from '@doveit/bricks';
import React from 'react';

export const AgentConversionRateSummaryCardSkeleton: React.FC = () => (
  <Card aria-label="Metrica di conversione in caricamento">
    <Card.Content>
      <Spacing padding={[50, 0]}>
        <HStack
          gap={300}
          alignItems="start"
          wrap="nowrap"
        >
          <div style={{ width: '6.25rem' }}>
            <Stack alignItems="center" gap={150}>
              <Skeleton
                circle
                width="4.5rem"
                height="4.5rem"
              />
              <Skeleton height="0.65rem" width="4.5rem" />
            </Stack>
          </div>

          <Spacing padding={[75, 0]}>
            <Stack gap={150}>
              <Skeleton height="1rem" width="12rem" />
            </Stack>
          </Spacing>
        </HStack>
      </Spacing>
    </Card.Content>
  </Card>
);

export default AgentConversionRateSummaryCardSkeleton;
